<template>
  <common-dialog ref="dialog" :title="title" width="1100px" :in-dialog="inDialog">
    <div class="index-tree-box">
      <type-tree ref="tree" auto-h show-action @on-select="treeSelect" @title-click="titleClick" />
      <div class="right-box">
        <list ref="list" common :show-checkbox="multiple" :showTrendTable="false"   >
          <template #column>
            <slot name="column" />
            <template v-if="selectable&&!multiple">
              <el-table-column label="操作" align="center" width="60" fixed="right">
                <template slot-scope="{row}">
                  <el-button :disabled="row.DistrictId==NoId" @click="onSelect(row)" type="text">选择</el-button>
                </template>
              </el-table-column>
            </template>
          </template>
        </list>
      </div>
    </div>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple" v-if="selectable&&multiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";
import typeTree from "./type/tree";

export default {
  components: { commonDialog, list, typeTree },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "计量单位列表",
    },
    selectable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      params: {},
      NoId: 0,
    };
  },
  methods: {
    getData(params = {}) {
      // console.log('我执行到这');
      // this.NoId = params.NoId;
      this.params = { ...params };
      this.$refs.list.getData(this.params);
      this.$refs.tree.getData();
    },
    treeSelect(data) {
      console.log('data',data);
      this.params.IsGroup = data.mode == 1 ? true : false
      this.$refs.list.getData({ ...this.params, UnitGroupId: data.UnitGroupId});
    },
    titleClick() {
      console.log('data',data);
      this.$refs.list.getData({ ...this.params });
    },
  },
};
</script>